/**
 * Education level options for audience targeting.
 * Sourced by id_spine; keep this list in sync with the id_spine data source when values change.
 */
export const Educations = [
  '',
  'High School or Less',
  'Some college, but no degree',
  'Some graduate studies, but no grad degree',
  'Graduate Degree (Masters, Doctorate, etc.)',
  'Vocational Training',
  'Associate Degree',
  'College Degree (such as B.A., B.S.)',
  'None of the Above',
];

export type Education = (typeof Educations)[number];
